var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_404",
    "data-name": 404,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 511.535,
    viewBox: "0 0 512 511.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2877",
    "data-name": "Rectangle 2877",
    width: 512,
    height: 511.535,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7604",
    "data-name": "Path 7604",
    d: "M279.54,440.725a42.543,42.543,0,1,0,42.544-42.543,42.544,42.544,0,0,0-42.544,42.543",
    transform: "translate(-279.54 -398.182)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2861",
    "data-name": "Rectangle 2861",
    width: 71.299,
    height: 66.507,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7642",
    "data-name": "Path 7642",
    d: "M280.006,305.365a6.211,6.211,0,0,0-5.7,6.683c1.027,12.924-3.569,38.562-13.849,50.34a25.171,25.171,0,0,1-18.394,8.977c-18.733,1.037-30.412-16.917-34.709-32.627l-.141-.537a7.766,7.766,0,1,0-15.032,3.907l.192.723c5.647,20.641,21.538,44.113,48,44.112q1.268,0,2.57-.074A40.5,40.5,0,0,0,272.156,372.6c14.157-16.217,15.676-47.152,14.534-61.536a6.2,6.2,0,0,0-6.183-5.72c-.166,0-.333.007-.5.02",
    transform: "translate(-191.93 -305.345)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2866",
    "data-name": "Rectangle 2866",
    width: 76.099,
    height: 81.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7660",
    "data-name": "Path 7660",
    d: "M224.38,230.806s-11.531,33.412-5.323,59.43,28.976,34.594,28.976,34.594-16.853,5.913-13.009,15.079,18.331,3.252,23.062.3,10.645-11.827,11.531-17.74a42.69,42.69,0,0,0,.592-9.166s19.219-2.07,32.228-12.714c0,0,11.531,9.166,19.81,7.391s20.105-16.557,18.923-29.862-8.87-13.306-13.6-11.235-6.5,4.139-6.5,4.139,6.8-8.278,0-19.809a25.824,25.824,0,0,0-18.924-12.418s-3.547-18.923-14.192-26.019c-4.551-3.034-14.073-6.121-24.662-6.121-14.181,0-30.275,5.537-38.907,24.157",
    transform: "translate(-217.222 -206.649)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2868",
    "data-name": "Rectangle 2868",
    width: 123.935,
    height: 138.176,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7680",
    "data-name": "Path 7680",
    d: "M198.053,214.5s-12.417,17.444-14.192,35.184.295,29.568,5.618,34,10.645,2.661,13.6-1.478-1.774-18.627-1.774-18.627,5.026-13.9,12.713-23.653,9.166-11.236,9.166-11.236-12.556-14.228-24.115-14.23c-.34,0-.679.012-1.018.038",
    transform: "translate(-183.24 -214.461)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2870",
    "data-name": "Rectangle 2870",
    width: 32.368,
    height: 28.481,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7691",
    "data-name": "Path 7691",
    d: "M278.336,221.832s1.616,1.325,10.223,10.282,14.973,22.293,14.973,22.293-3.288,14.882.061,18.712,8.819,5.073,13.68.137,5.762-16.909,2.256-34.389-17.575-33.624-17.575-33.624c-11.856.277-23.619,16.59-23.619,16.59",
    transform: "translate(-278.336 -205.242)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2872",
    "data-name": "Rectangle 2872",
    width: 33.379,
    height: 32.214,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7704",
    "data-name": "Path 7704",
    d: "M281.522,149.206s-14.635-7.775-41.164-3.2-34.3,12.349-34.3,12.349-32.932,4.116-35.218,8.233,4.573,21.5,25.155,27.9c0,0-3.659,12.349-2.286,17.381s7.775.457,14.179,5.946,12.338,15.361,36.58,17.191,38.888-11.245,43.919-18.563,4.574-16.008,13.264-16.466,1.373-17.381-1.372-20.125c0,0,16.923-25.156,16.923-31.56,0-2.908-3.3-4.213-8.752-4.213-6.547,0-16.19,1.882-26.924,5.128",
    transform: "translate(-170.416 -144.078)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2874",
    "data-name": "Rectangle 2874",
    width: 136.702,
    height: 72.291,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2875",
    "data-name": "Rectangle 2875",
    width: 29.968,
    height: 11.046,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8738",
    "data-name": "Group 8738",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8692",
    "data-name": "Group 8692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8691",
    "data-name": "Group 8691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7587",
    "data-name": "Path 7587",
    d: "M1.15,273.737s2.786,86.353,74.87,143.909,171.973,61.677,252.836,67.144S471.83,444.481,481.191,375.282,428.762,285.771,395.237,207,364.7,102.341,293.761,53.895s-181.9-18.7-240.081,64.3S1.15,273.737,1.15,273.737",
    transform: "translate(-0.07 -2.139)",
    fill: "#f1f3f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7588",
    "data-name": "Path 7588",
    d: "M1.15,273.737s2.786,86.353,74.87,143.909,171.973,61.677,252.836,67.144S471.83,444.481,481.191,375.282,428.762,285.771,395.237,207,364.7,102.341,293.761,53.895s-181.9-18.7-240.081,64.3S1.15,273.737,1.15,273.737Z",
    transform: "translate(-0.07 -2.139)",
    fill: "none",
    stroke: "#b5bccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 10.904,
    transform: "translate(22.98 411.038)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 424.552,
    transform: "translate(51.145 411.038)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7589",
    "data-name": "Path 7589",
    d: "M373.114,479.541c0,5.485-16.169,9.931-36.114,9.931s-36.114-4.447-36.114-9.931S317.054,469.61,337,469.61s36.114,4.447,36.114,9.931",
    transform: "translate(-21.043 -32.843)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7590",
    "data-name": "Path 7590",
    d: "M135.8,501.86c-37.574,0-43.121-5.432-43.669-9.815a5.94,5.94,0,0,1,1.71-5.03c10.126-10.618,68.455-6.127,149.186.09,11.259.867,22.907,1.763,34.85,2.651,81.571,6.061,114.41,5.273,121.163-2.92,1.384-1.681,1.672-3.776.9-6.6-3.225-11.829-46.423-11.921-62.791-10.963a1.411,1.411,0,1,1-.166-2.818c6.259-.366,61.272-3.13,65.682,13.039,1.018,3.73.543,6.717-1.449,9.134-7.621,9.245-38.795,10.235-123.551,3.939-11.946-.887-23.594-1.784-34.857-2.651-76.948-5.927-137.727-10.608-146.926-.956a3.156,3.156,0,0,0-.952,2.73c.349,2.8,7.067,9.068,61.8,6.882,30.569-1.218,61.287-4.548,61.593-4.581a1.412,1.412,0,1,1,.306,2.807c-.307.033-31.109,3.371-61.774,4.595-7.947.317-14.928.462-21.055.462",
    transform: "translate(-6.44 -32.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7591",
    "data-name": "Path 7591",
    d: "M135.8,501.86c-37.574,0-43.121-5.432-43.669-9.815a5.94,5.94,0,0,1,1.71-5.03c10.126-10.618,68.455-6.127,149.186.09,11.259.867,22.907,1.763,34.85,2.651,81.571,6.061,114.41,5.273,121.163-2.92,1.384-1.681,1.672-3.776.9-6.6-3.225-11.829-46.423-11.921-62.791-10.963a1.411,1.411,0,1,1-.166-2.818c6.259-.366,61.272-3.13,65.682,13.039,1.018,3.73.543,6.717-1.449,9.134-7.621,9.245-38.795,10.235-123.551,3.939-11.946-.887-23.594-1.784-34.857-2.651-76.948-5.927-137.727-10.608-146.926-.956a3.156,3.156,0,0,0-.952,2.73c.349,2.8,7.067,9.068,61.8,6.882,30.569-1.218,61.287-4.548,61.593-4.581a1.412,1.412,0,1,1,.306,2.807c-.307.033-31.109,3.371-61.774,4.595C148.911,501.715,141.931,501.86,135.8,501.86Z",
    transform: "translate(-6.44 -32.594)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7592",
    "data-name": "Path 7592",
    d: "M364.627,440.725a42.543,42.543,0,1,0-42.543,42.543,42.543,42.543,0,0,0,42.543-42.543",
    transform: "translate(-19.55 -27.847)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8697",
    "data-name": "Group 8697",
    transform: "translate(259.99 370.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8696",
    "data-name": "Group 8696",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7593",
    "data-name": "Path 7593",
    d: "M323.12,484.666a42.543,42.543,0,0,0,35.152-66.507c-.471,18.529-10.718,45.892-63.907,55.312a42.389,42.389,0,0,0,28.756,11.2",
    transform: "translate(-280.577 -399.579)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8695",
    "data-name": "Group 8695",
    transform: "translate(13.788 18.579)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8694",
    "data-name": "Group 8694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8693",
    "data-name": "Group 8693",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7594",
    "data-name": "Path 7594",
    d: "M323.12,484.666a42.543,42.543,0,0,0,35.152-66.507c-.471,18.529-10.718,45.892-63.907,55.312a42.389,42.389,0,0,0,28.756,11.2",
    transform: "translate(-294.365 -418.158)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7595",
    "data-name": "Path 7595",
    d: "M344.728,457.409a67.641,67.641,0,0,0-26.9-16.046,67.641,67.641,0,0,1,26.9,16.046c.751.01,1.487.03,2.254.031a78.326,78.326,0,0,0,12.818-16.71c-19.928-21.082-39.364-18.928-39.364-18.928s19.436-2.154,39.364,18.928c1.1-1.955,2.011-3.8,2.761-5.5-8.242-11.617-22.518-19.5-30.231-20.713l-1.784-.42a25.086,25.086,0,0,0-8.372-.118,25.086,25.086,0,0,1,8.372.118l5.077-14.217a42.463,42.463,0,0,0-7.338-1.407c-3.281,5.307-11.763,22.273-11.763,55.932,0-33.659,8.481-50.625,11.763-55.932q-2.123-.212-4.305-.216a43.118,43.118,0,0,0-4.816.278c-5.013,7.583-14.6,25.493-15.247,52.369C313.911,454.458,327.224,457.156,344.728,457.409Zm9.613-8.657c-16.953-16.518-35.645-17.388-35.645-17.388S337.388,432.234,354.341,448.752Z",
    transform: "translate(-281.245 -398.187)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7596",
    "data-name": "Path 7596",
    d: "M303.1,450.922c.645-26.875,10.233-44.786,15.247-52.369a42.4,42.4,0,0,0-11.421,2.932,84.766,84.766,0,0,0-14.674,44.67A77.781,77.781,0,0,0,303.1,450.922Z",
    transform: "translate(-280.429 -398.208)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7597",
    "data-name": "Path 7597",
    d: "M306.055,401.706a42.64,42.64,0,0,0-26.281,36.5,55.369,55.369,0,0,0,11.607,8.17A84.763,84.763,0,0,1,306.055,401.706Z",
    transform: "translate(-279.556 -398.429)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7598",
    "data-name": "Path 7598",
    d: "M364.563,435.35a53.174,53.174,0,0,0,2.335-6.3,42.532,42.532,0,0,0-9.065-16.364L354.6,423.661l3.228-10.977a42.843,42.843,0,0,0-8.964-7.635l-3.63,13.558,3.63-13.558A42.363,42.363,0,0,0,337.625,400l-5.077,14.216C340.261,415.431,352.329,420.015,364.563,435.35Z",
    transform: "translate(-283.247 -398.309)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7599",
    "data-name": "Path 7599",
    d: "M367.1,445.043c.026-.616.046-1.232.046-1.855a42.6,42.6,0,0,0-1.712-11.957,53.167,53.167,0,0,1-2.335,6.3l.04.048-.04-.048a27.224,27.224,0,0,1-1.806,3.635c.064.068-1.019,1.8-.955,1.866-.064-.068-1.135,2.138-1.2,2.07-2.826,5.025-11.353,14.647-11.216,14.647-.138,0-4.608,4.051-7.053,6.094l.1-.008-.1.008a116.223,116.223,0,0,1-14.122,10.041c.1-.019.209-.031.31-.051-.1.02-.207.033-.31.051a147.239,147.239,0,0,1-15.076,7.958,42.6,42.6,0,0,0,12.846,1.974q1.077,0,2.142-.054C335.273,481.084,349.133,470.216,367.1,445.043Z",
    transform: "translate(-281.788 -400.493)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7600",
    "data-name": "Path 7600",
    d: "M368.231,446.082c-17.971,25.172-31.831,36.041-40.439,40.72A42.627,42.627,0,0,0,368.231,446.082Z",
    transform: "translate(-282.915 -401.532)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7601",
    "data-name": "Path 7601",
    d: "M289.663,472.66a42.67,42.67,0,0,0,20.474,14.081,147.038,147.038,0,0,0,15.076-7.958C315.067,480.658,299.2,476.006,289.663,472.66Z",
    transform: "translate(-280.248 -403.391)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7602",
    "data-name": "Path 7602",
    d: "M324.621,477.605a116.328,116.328,0,0,0,14.122-10.04c-30.636,3.133-49.54-6.35-57.567-11.75a42.466,42.466,0,0,0,7.894,15.667C298.606,474.828,314.474,479.48,324.621,477.605Z",
    transform: "translate(-279.654 -402.213)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7603",
    "data-name": "Path 7603",
    d: "M338.637,466.526c2.445-2.042,4.643-4.081,6.647-6.1-.766,0-1.5-.02-2.254-.031.162.158.325.311.485.472-.16-.161-.323-.313-.485-.472-17.5-.253-30.818-2.951-40.81-6.507v0c-14.6-5.059-19.859-10.51-22.455-12.936-.066.964-.111,1.935-.111,2.918a42.718,42.718,0,0,0,1.414,10.906C289.1,460.176,308,469.659,338.637,466.526Z",
    transform: "translate(-279.548 -401.173)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8699",
    "data-name": "Group 8699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8698",
    "data-name": "Group 8698",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7605",
    "data-name": "Path 7605",
    d: "M364.627,440.725a42.543,42.543,0,1,0-42.543,42.543A42.543,42.543,0,0,0,364.627,440.725Z",
    transform: "translate(-19.55 -27.847)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7606",
    "data-name": "Path 7606",
    d: "M404.863,364.656s-2.908-9.454-11.393-12.848c-5.9-2.359-12.684-1.741-18.793-.679-11.384,1.98-21.318,6.507-32.111,10.376,0,0,4.606-1.7,23.513,7.514,6.964,3.393,14.928,6.026,22.891,5.847,6.4-.143,16.2-1.965,15.894-10.21",
    transform: "translate(-23.958 -24.491)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7607",
    "data-name": "Path 7607",
    d: "M404.863,364.656s-2.908-9.454-11.393-12.848c-5.9-2.359-12.684-1.741-18.793-.679-11.384,1.98-21.318,6.507-32.111,10.376,0,0,4.606-1.7,23.513,7.514,6.964,3.393,14.928,6.026,22.891,5.847C395.367,374.723,405.168,372.9,404.863,364.656Z",
    transform: "translate(-23.958 -24.491)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7608",
    "data-name": "Path 7608",
    d: "M406.234,334.209s-.054-9.89-7.2-15.591c-4.965-3.962-11.642-5.332-17.8-6.079-11.47-1.393-22.288.071-33.739.657,0,0,4.9-.294,20.34,13.986,5.686,5.259,12.55,10.081,20.225,12.211,6.167,1.71,16.076,2.8,18.166-5.184",
    transform: "translate(-24.303 -21.817)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7609",
    "data-name": "Path 7609",
    d: "M406.234,334.209s-.054-9.89-7.2-15.591c-4.965-3.962-11.642-5.332-17.8-6.079-11.47-1.393-22.288.071-33.739.657,0,0,4.9-.294,20.34,13.986,5.686,5.259,12.55,10.081,20.225,12.211C394.235,341.1,404.144,342.19,406.234,334.209Z",
    transform: "translate(-24.303 -21.817)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7610",
    "data-name": "Path 7610",
    d: "M431.084,370.928s-7.715-6.19-7.742-15.327c-.018-6.35,3.058-12.433,6.3-17.72,6.038-9.853,13.908-17.417,21.484-26.023,0,0-3.275,3.654-1.683,24.627.586,7.724.1,16.1-3.006,23.434-2.492,5.895-7.8,14.333-15.351,11.008",
    transform: "translate(-29.607 -21.81)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7611",
    "data-name": "Path 7611",
    d: "M431.084,370.928s-7.715-6.19-7.742-15.327c-.018-6.35,3.058-12.433,6.3-17.72,6.038-9.853,13.908-17.417,21.484-26.023,0,0-3.275,3.654-1.683,24.627.586,7.724.1,16.1-3.006,23.434C443.943,365.815,438.636,374.253,431.084,370.928Z",
    transform: "translate(-29.607 -21.81)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7612",
    "data-name": "Path 7612",
    d: "M461.037,389.623s-1.09-9.831,5.345-16.319c4.473-4.508,10.946-6.642,16.974-8.1,11.232-2.709,22.147-2.507,33.588-3.249,0,0-4.9.274-18.585,16.244-5.041,5.883-11.3,11.465-18.678,14.467-5.927,2.413-15.645,4.639-18.643-3.048",
    transform: "translate(-32.238 -25.314)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7613",
    "data-name": "Path 7613",
    d: "M461.037,389.623s-1.09-9.831,5.345-16.319c4.473-4.508,10.946-6.642,16.974-8.1,11.232-2.709,22.147-2.507,33.588-3.249,0,0-4.9.274-18.585,16.244-5.041,5.883-11.3,11.465-18.678,14.467C473.753,395.083,464.035,397.31,461.037,389.623Z",
    transform: "translate(-32.238 -25.314)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7614",
    "data-name": "Path 7614",
    d: "M457.746,349.442s-9.8-1.348-14.515-9.174c-3.278-5.44-3.763-12.239-3.7-18.439.12-11.554,2.986-22.088,5.066-33.363,0,0-.932,4.819,11.205,22,4.47,6.326,8.351,13.762,9.458,21.65.89,6.337.671,16.3-7.516,17.331",
    transform: "translate(-30.739 -20.174)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7615",
    "data-name": "Path 7615",
    d: "M457.746,349.442s-9.8-1.348-14.515-9.174c-3.278-5.44-3.763-12.239-3.7-18.439.12-11.554,2.986-22.088,5.066-33.363,0,0-.932,4.819,11.205,22,4.47,6.326,8.351,13.762,9.458,21.65C466.152,338.449,465.932,348.415,457.746,349.442Z",
    transform: "translate(-30.739 -20.174)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7616",
    "data-name": "Path 7616",
    d: "M489.349,333.09s7.048,6.941,16.126,5.9c6.31-.724,11.991-4.488,16.863-8.324,9.079-7.148,15.674-15.846,23.337-24.375,0,0-3.248,3.679-24.263,4.548-7.739.32-16,1.784-22.922,5.721-5.563,3.163-13.324,9.419-9.142,16.53",
    transform: "translate(-34.14 -21.421)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7617",
    "data-name": "Path 7617",
    d: "M489.349,333.09s7.048,6.941,16.126,5.9c6.31-.724,11.991-4.488,16.863-8.324,9.079-7.148,15.674-15.846,23.337-24.375,0,0-3.248,3.679-24.263,4.548-7.739.32-16,1.784-22.922,5.721C492.927,319.723,485.166,325.979,489.349,333.09Z",
    transform: "translate(-34.14 -21.421)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7618",
    "data-name": "Path 7618",
    d: "M480.256,323.5s9.842.989,16.263-5.512c4.462-4.519,6.529-11.014,7.92-17.056,2.594-11.26,2.28-22.172,2.9-33.621,0,0-.224,4.9-16.053,18.753-5.83,5.1-11.348,11.418-14.275,18.826-2.351,5.952-4.476,15.691,3.24,18.611",
    transform: "translate(-33.209 -18.695)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7619",
    "data-name": "Path 7619",
    d: "M480.256,323.5s9.842.989,16.263-5.512c4.462-4.519,6.529-11.014,7.92-17.056,2.594-11.26,2.28-22.172,2.9-33.621,0,0-.224,4.9-16.053,18.753-5.83,5.1-11.348,11.418-14.275,18.826C474.665,310.845,472.54,320.584,480.256,323.5Z",
    transform: "translate(-33.209 -18.695)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7620",
    "data-name": "Path 7620",
    d: "M440.134,423.934l-16.986-41.81-19.6-48.344",
    transform: "translate(-28.223 -23.343)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7621",
    "data-name": "Path 7621",
    d: "M447.1,415.912l16.986-58.143,18.292-35.931",
    transform: "translate(-31.269 -22.508)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y1: 9.799,
    x2: 16.986,
    transform: "translate(422.365 360.74)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 8.492,
    y1: 18.945,
    transform: "translate(424.325 316.316)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y1: 9.24,
    x2: 20.729,
    transform: "translate(443.445 307.17)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y1: 28.745,
    x2: 7.187,
    transform: "translate(398.192 337.875)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 16.601,
    y1: 8.856,
    transform: "translate(372.061 335.915)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7622",
    "data-name": "Path 7622",
    d: "M450.08,450.586H435.912a9.944,9.944,0,0,1-9.77-8.092l-5.031-26.533h43.77l-5.031,26.533a9.944,9.944,0,0,1-9.77,8.092",
    transform: "translate(-29.451 -29.091)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7623",
    "data-name": "Path 7623",
    d: "M23.651,278.844c0-3.292,1.517-5.712,4.938-5.712,3.485,0,5,2.421,5,5.712V290.4c0,3.291-1.517,5.711-5,5.711-3.421,0-4.938-2.42-4.938-5.711Zm1.485,11.65c0,2.452.968,4.26,3.452,4.26,2.518,0,3.517-1.808,3.517-4.26V278.748c0-2.453-1-4.261-3.517-4.261-2.484,0-3.452,1.808-3.452,4.261Z",
    transform: "translate(-1.654 -19.102)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7624",
    "data-name": "Path 7624",
    d: "M36.874,278.844c0-3.292,1.517-5.712,4.938-5.712,3.485,0,5,2.421,5,5.712V290.4c0,3.291-1.517,5.711-5,5.711-3.421,0-4.938-2.42-4.938-5.711Zm1.485,11.65c0,2.452.968,4.26,3.452,4.26,2.518,0,3.517-1.808,3.517-4.26V278.748c0-2.453-1-4.261-3.517-4.261-2.484,0-3.452,1.808-3.452,4.261Z",
    transform: "translate(-2.579 -19.102)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7625",
    "data-name": "Path 7625",
    d: "M54.879,273.341c3.485,0,4.84,2.194,4.84,5.486v2.453c0,3.583-1.646,5.357-5.228,5.357H51.684v9.294H50.2V273.341Zm-.388,11.94c2.614,0,3.744-1.162,3.744-3.9v-2.646c0-2.454-.838-4.035-3.356-4.035H51.684v10.585Z",
    transform: "translate(-3.511 -19.117)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7626",
    "data-name": "Path 7626",
    d: "M72.338,278.78v.484h-1.42v-.581c0-2.388-.9-4.2-3.356-4.2s-3.356,1.775-3.356,4.164c0,5.485,8.165,5.583,8.165,11.811,0,3.26-1.42,5.647-4.874,5.647s-4.872-2.387-4.872-5.647V289.3h1.419v1.258c0,2.42.936,4.163,3.421,4.163s3.421-1.743,3.421-4.163c0-5.421-8.165-5.518-8.165-11.811,0-3.389,1.485-5.583,4.809-5.616,3.421,0,4.807,2.388,4.807,5.648",
    transform: "translate(-4.38 -19.102)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2862",
    "data-name": "Rectangle 2862",
    width: 1.454,
    height: 2.84,
    transform: "translate(70.219 273.974)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2863",
    "data-name": "Rectangle 2863",
    width: 1.453,
    height: 2.84,
    transform: "translate(74.255 273.974)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 1.454,
    height: 2.84,
    transform: "translate(78.288 273.974)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7627",
    "data-name": "Path 7627",
    d: "M28.435,308.68c3.485,0,4.84,2.194,4.84,5.486v2.453c0,3.583-1.646,5.357-5.228,5.357H25.24v9.294H23.755V308.68Zm-.388,11.94c2.614,0,3.744-1.162,3.744-3.9v-2.647c0-2.453-.838-4.034-3.356-4.034H25.24V320.62Z",
    transform: "translate(-1.661 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7628",
    "data-name": "Path 7628",
    d: "M38.075,326.265l-1.129,5H35.591l4.937-22.622h2.163l5.034,22.622H46.239l-1.129-5Zm.226-1.291h6.583L41.56,310.355Z",
    transform: "translate(-2.489 -21.586)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7629",
    "data-name": "Path 7629",
    d: "M60.677,314.184v1.678H59.256v-1.775c0-2.42-.936-4.26-3.421-4.26s-3.421,1.84-3.421,4.26v11.747c0,2.42.937,4.227,3.421,4.227s3.421-1.807,3.421-4.227v-4.873h-3V319.6h4.422v6.132c0,3.259-1.421,5.712-4.874,5.712s-4.872-2.453-4.872-5.712V314.184c0-3.259,1.42-5.712,4.872-5.712s4.874,2.453,4.874,5.712",
    transform: "translate(-3.562 -21.573)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7630",
    "data-name": "Path 7630",
    d: "M71.731,319.135v1.356H65.567v9.423h7.422v1.356H64.082V308.68h8.906v1.355H65.567v9.1Z",
    transform: "translate(-4.482 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7631",
    "data-name": "Path 7631",
    d: "M83,331.269H81.643V308.68H83.58l6.776,19.072V308.68h1.356v22.589H90.065L83,311.132Z",
    transform: "translate(-5.71 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7632",
    "data-name": "Path 7632",
    d: "M95.109,314.183c0-3.292,1.516-5.712,4.937-5.712,3.486,0,5,2.421,5,5.712v11.553c0,3.292-1.516,5.712-5,5.712-3.421,0-4.937-2.42-4.937-5.712Zm1.484,11.65c0,2.452.968,4.26,3.452,4.26,2.518,0,3.517-1.808,3.517-4.26V314.087c0-2.453-1-4.26-3.517-4.26-2.484,0-3.452,1.807-3.452,4.26Z",
    transform: "translate(-6.652 -21.573)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7633",
    "data-name": "Path 7633",
    d: "M112.183,331.269V310.035H107.6V308.68h10.681v1.355h-4.614v21.234Z",
    transform: "translate(-7.525 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7634",
    "data-name": "Path 7634",
    d: "M133.771,319.684v1.355h-5.84V331.27h-1.485v-22.59h8.584v1.356h-7.1v9.648Z",
    transform: "translate(-8.843 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7635",
    "data-name": "Path 7635",
    d: "M138,314.183c0-3.292,1.516-5.712,4.937-5.712,3.486,0,5,2.421,5,5.712v11.553c0,3.292-1.516,5.712-5,5.712-3.421,0-4.937-2.42-4.937-5.712Zm1.484,11.65c0,2.452.968,4.26,3.452,4.26,2.518,0,3.518-1.808,3.518-4.26V314.087c0-2.453-1-4.26-3.518-4.26-2.484,0-3.452,1.807-3.452,4.26Z",
    transform: "translate(-9.651 -21.573)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7636",
    "data-name": "Path 7636",
    d: "M152.744,325.815c0,2.42.9,4.292,3.389,4.292s3.388-1.872,3.388-4.292V308.679h1.388V325.75c0,3.227-1.355,5.712-4.808,5.712s-4.841-2.485-4.841-5.712V308.679h1.484Z",
    transform: "translate(-10.579 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7637",
    "data-name": "Path 7637",
    d: "M165.734,331.269h-1.355V308.68h1.936l6.776,19.072V308.68h1.356v22.589H172.8l-7.068-20.137Z",
    transform: "translate(-11.496 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7638",
    "data-name": "Path 7638",
    d: "M182.918,308.68c3.485,0,5,2.292,5,5.616v11.359c0,3.323-1.517,5.615-5,5.615h-4.97V308.68Zm-.033,21.234c2.518,0,3.55-1.71,3.55-4.2V314.231c0-2.485-1.064-4.2-3.55-4.2h-3.452v19.879Z",
    transform: "translate(-12.445 -21.588)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7639",
    "data-name": "Path 7639",
    d: "M240.368,386.943c-26.456,0-42.348-23.47-47.994-44.111l-.192-.724a7.765,7.765,0,1,1,15.031-3.907l.141.538c4.3,15.71,15.977,33.663,34.709,32.626a25.171,25.171,0,0,0,18.394-8.976c10.28-11.777,14.875-37.416,13.849-50.34a6.212,6.212,0,0,1,12.385-.984c1.143,14.383-.377,45.317-14.534,61.536a40.5,40.5,0,0,1-29.219,14.269q-1.3.073-2.57.073",
    transform: "translate(-13.423 -21.355)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8704",
    "data-name": "Group 8704",
    transform: "translate(178.507 283.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8703",
    "data-name": "Group 8703",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7640",
    "data-name": "Path 7640",
    d: "M281.432,305.366a6.212,6.212,0,0,0-5.7,6.684c.5,6.307-.341,15.641-2.525,24.915a27.373,27.373,0,0,1,9.226,1.2,49.033,49.033,0,0,1-9.067,24.795c-11.539,16.026-28.848,21.154-42.31,19.232-6.018-.859-12.929-4.025-18.735-7.263,7.679,7.188,17.488,12.013,29.473,12.012q1.268,0,2.569-.073a40.508,40.508,0,0,0,29.22-14.27c14.157-16.217,15.676-47.152,14.534-61.535a6.2,6.2,0,0,0-6.684-5.7",
    transform: "translate(-193.356 -305.345)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8702",
    "data-name": "Group 8702",
    transform: "translate(18.965)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8701",
    "data-name": "Group 8701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8700",
    "data-name": "Group 8700",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7641",
    "data-name": "Path 7641",
    d: "M281.432,305.366a6.212,6.212,0,0,0-5.7,6.684c.5,6.307-.341,15.641-2.525,24.915a27.373,27.373,0,0,1,9.226,1.2,49.033,49.033,0,0,1-9.067,24.795c-11.539,16.026-28.848,21.154-42.31,19.232-6.018-.859-12.929-4.025-18.735-7.263,7.679,7.188,17.488,12.013,29.473,12.012q1.268,0,2.569-.073a40.508,40.508,0,0,0,29.22-14.27c14.157-16.217,15.676-47.152,14.534-61.535a6.2,6.2,0,0,0-6.684-5.7",
    transform: "translate(-212.321 -305.345)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8706",
    "data-name": "Group 8706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8705",
    "data-name": "Group 8705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7643",
    "data-name": "Path 7643",
    d: "M240.368,386.943c-26.456,0-42.348-23.47-47.994-44.111l-.192-.724a7.765,7.765,0,1,1,15.031-3.907l.141.538c4.3,15.71,15.977,33.663,34.709,32.626a25.171,25.171,0,0,0,18.394-8.976c10.28-11.777,14.875-37.416,13.849-50.34a6.212,6.212,0,0,1,12.385-.984c1.143,14.383-.377,45.317-14.534,61.536a40.5,40.5,0,0,1-29.219,14.269Q241.637,386.942,240.368,386.943Z",
    transform: "translate(-13.423 -21.355)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7644",
    "data-name": "Path 7644",
    d: "M226.689,375.72c.623-2.91-6.34,1.646-12.173,5.884a45.963,45.963,0,0,0,6.943,4.831c2.082-3.379,4.627-7.9,5.23-10.715",
    transform: "translate(-15.002 -26.212)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7645",
    "data-name": "Path 7645",
    d: "M226.689,375.72c.623-2.91-6.34,1.646-12.173,5.884a45.963,45.963,0,0,0,6.943,4.831C223.541,383.056,226.086,378.532,226.689,375.72Z",
    transform: "translate(-15.002 -26.212)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7646",
    "data-name": "Path 7646",
    d: "M243.637,392.213q1.268,0,2.57-.073a44.785,44.785,0,0,0,7.5-1.059c-3.278-4.28-7.787-9.926-9.09-10.36-1.483-.494-4.346,6.79-5.933,11.207a43.094,43.094,0,0,0,4.955.286",
    transform: "translate(-16.693 -26.625)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7647",
    "data-name": "Path 7647",
    d: "M243.637,392.213q1.268,0,2.57-.073a44.785,44.785,0,0,0,7.5-1.059c-3.278-4.28-7.787-9.926-9.09-10.36-1.483-.494-4.346,6.79-5.933,11.207A43.094,43.094,0,0,0,243.637,392.213Z",
    transform: "translate(-16.693 -26.625)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    d: "M207.354,340.774l-.142-.538a7.765,7.765,0,1,0-15.03,3.907l.191.724a76.124,76.124,0,0,0,9.032,20.527l14.15-6.738a59.35,59.35,0,0,1-8.2-17.882",
    transform: "translate(-13.423 -23.388)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7649",
    "data-name": "Path 7649",
    d: "M207.354,340.774l-.142-.538a7.765,7.765,0,1,0-15.03,3.907l.191.724a76.124,76.124,0,0,0,9.032,20.527l14.15-6.738A59.35,59.35,0,0,1,207.354,340.774Z",
    transform: "translate(-13.423 -23.388)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7650",
    "data-name": "Path 7650",
    d: "M277.306,377.1a39.578,39.578,0,0,0,3.019-3.969c-4.486-1.535-11.215-3.643-13.712-3.416-2.961.269,1.057,9.773,3.131,14.27a43.5,43.5,0,0,0,7.562-6.884",
    transform: "translate(-18.572 -25.855)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7651",
    "data-name": "Path 7651",
    d: "M277.306,377.1a39.578,39.578,0,0,0,3.019-3.969c-4.486-1.535-11.215-3.643-13.712-3.416-2.961.269,1.057,9.773,3.131,14.27A43.5,43.5,0,0,0,277.306,377.1Z",
    transform: "translate(-18.572 -25.855)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7652",
    "data-name": "Path 7652",
    d: "M278.454,350.106c-.471.942,5.34,5.18,9.261,7.9a89.71,89.71,0,0,0,3-11.314c-4.757.945-11.791,2.485-12.256,3.414",
    transform: "translate(-19.472 -24.246)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7653",
    "data-name": "Path 7653",
    d: "M278.454,350.106c-.471.942,5.34,5.18,9.261,7.9a89.71,89.71,0,0,0,3-11.314C285.953,347.637,278.919,349.177,278.454,350.106Z",
    transform: "translate(-19.472 -24.246)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7654",
    "data-name": "Path 7654",
    d: "M293.061,330.743c.264-3.386.387-6.621.4-9.594-4.086,2.255-8.937,5.363-8.937,7.406,0,1.977,4.54,2.293,8.533,2.188",
    transform: "translate(-19.899 -22.46)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7655",
    "data-name": "Path 7655",
    d: "M293.061,330.743c.264-3.386.387-6.621.4-9.594-4.086,2.255-8.937,5.363-8.937,7.406C284.528,330.531,289.068,330.847,293.061,330.743Z",
    transform: "translate(-19.899 -22.46)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7656",
    "data-name": "Path 7656",
    d: "M224.38,230.805s-11.531,33.411-5.322,59.43,28.975,34.594,28.975,34.594-16.853,5.913-13.01,15.079,18.332,3.252,23.063.3,10.645-11.827,11.531-17.741a42.692,42.692,0,0,0,.592-9.166s19.219-2.069,32.229-12.713c0,0,11.531,9.166,19.809,7.391s20.106-16.557,18.923-29.862-8.87-13.306-13.6-11.236-6.5,4.14-6.5,4.14,6.8-8.278,0-19.81a25.823,25.823,0,0,0-18.923-12.418s-3.548-18.923-14.193-26.019-48.49-14.489-63.569,18.036",
    transform: "translate(-15.192 -14.452)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8711",
    "data-name": "Group 8711",
    transform: "translate(202.03 192.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8710",
    "data-name": "Group 8710",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7657",
    "data-name": "Path 7657",
    d: "M312.233,242.3a67.056,67.056,0,0,1-52.111,32.342c-23.53,2.064-36.718-2.571-42.8-5.788a151.1,151.1,0,0,1,7.063-38.048c15.079-32.524,52.924-25.132,63.569-18.036s14.192,26.019,14.192,26.019a25.421,25.421,0,0,1,10.086,3.51m15.342,24.578c-4.73,2.07-6.5,4.141-6.5,4.141a15.573,15.573,0,0,0,2.773-6.7c-15.982,7.954-14.735,24.973-16.724,24.973-2.441,0-3.662-8.544-3.662-8.544S300.4,292.951,282.095,301.5s-39.063,1.83-39.063,1.83,4.273,9.766-6.713,8.546a18.086,18.086,0,0,1-8.589-3.139,50.9,50.9,0,0,0,20.311,16.1s-16.854,5.912-13.01,15.079,18.332,3.252,23.063.294,10.644-11.826,11.531-17.739a42.691,42.691,0,0,0,.591-9.166s19.218-2.07,32.228-12.714c0,0,11.531,9.166,19.81,7.392s20.105-16.559,18.923-29.863-8.87-13.3-13.6-11.236",
    transform: "translate(-217.229 -206.649)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8709",
    "data-name": "Group 8709",
    transform: "translate(0.095 -0.001)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8708",
    "data-name": "Group 8708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8707",
    "data-name": "Group 8707",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7658",
    "data-name": "Path 7658",
    d: "M312.233,242.3a67.056,67.056,0,0,1-52.111,32.342c-23.53,2.064-36.718-2.571-42.8-5.788a151.1,151.1,0,0,1,7.063-38.048c15.079-32.524,52.924-25.132,63.569-18.036s14.192,26.019,14.192,26.019a25.421,25.421,0,0,1,10.086,3.51m15.342,24.578c-4.73,2.07-6.5,4.141-6.5,4.141a15.573,15.573,0,0,0,2.773-6.7c-15.982,7.954-14.735,24.973-16.724,24.973-2.441,0-3.662-8.544-3.662-8.544S300.4,292.951,282.095,301.5s-39.063,1.83-39.063,1.83,4.273,9.766-6.713,8.546a18.086,18.086,0,0,1-8.589-3.139,50.9,50.9,0,0,0,20.311,16.1s-16.854,5.912-13.01,15.079,18.332,3.252,23.063.294,10.644-11.826,11.531-17.739a42.691,42.691,0,0,0,.591-9.166s19.218-2.07,32.228-12.714c0,0,11.531,9.166,19.81,7.392s20.105-16.559,18.923-29.863-8.87-13.3-13.6-11.236",
    transform: "translate(-217.324 -206.648)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7659",
    "data-name": "Path 7659",
    d: "M271.678,320.164a41.745,41.745,0,0,1-33.448-15.34",
    transform: "translate(-218.691 -213.515)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8713",
    "data-name": "Group 8713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8712",
    "data-name": "Group 8712",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7661",
    "data-name": "Path 7661",
    d: "M224.38,230.805s-11.531,33.411-5.322,59.43,28.975,34.594,28.975,34.594-16.853,5.913-13.01,15.079,18.332,3.252,23.063.3,10.645-11.827,11.531-17.741a42.692,42.692,0,0,0,.592-9.166s19.219-2.069,32.229-12.713c0,0,11.531,9.166,19.809,7.391s20.106-16.557,18.923-29.862-8.87-13.306-13.6-11.236-6.5,4.14-6.5,4.14,6.8-8.278,0-19.81a25.823,25.823,0,0,0-18.923-12.418s-3.548-18.923-14.193-26.019S239.459,198.281,224.38,230.805Z",
    transform: "translate(-15.192 -14.452)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7662",
    "data-name": "Path 7662",
    d: "M328.184,275.857s-6.209,4.14-9.166,16.854",
    transform: "translate(-22.311 -19.292)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7663",
    "data-name": "Path 7663",
    d: "M340.64,281.319c-.731,2.166-2.709,3.455-4.419,2.878s-2.5-2.8-1.773-4.967,2.708-3.454,4.419-2.878,2.5,2.8,1.773,4.967",
    transform: "translate(-23.371 -19.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7664",
    "data-name": "Path 7664",
    d: "M340.64,281.319c-.731,2.166-2.709,3.455-4.419,2.878s-2.5-2.8-1.773-4.967,2.708-3.454,4.419-2.878S341.371,279.153,340.64,281.319Z",
    transform: "translate(-23.371 -19.318)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    d: "M347.217,285.457c-.731,2.166-2.709,3.455-4.419,2.878s-2.5-2.8-1.774-4.967,2.709-3.454,4.42-2.878,2.5,2.8,1.773,4.967",
    transform: "translate(-23.831 -19.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7666",
    "data-name": "Path 7666",
    d: "M347.217,285.457c-.731,2.166-2.709,3.455-4.419,2.878s-2.5-2.8-1.774-4.967,2.709-3.454,4.42-2.878S347.948,283.291,347.217,285.457Z",
    transform: "translate(-23.831 -19.607)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7667",
    "data-name": "Path 7667",
    d: "M348.751,291.756c-.531,1.573-1.967,2.509-3.21,2.09s-1.818-2.033-1.287-3.607,1.968-2.509,3.21-2.09,1.818,2.033,1.287,3.607",
    transform: "translate(-24.062 -20.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7668",
    "data-name": "Path 7668",
    d: "M348.751,291.756c-.531,1.573-1.967,2.509-3.21,2.09s-1.818-2.033-1.287-3.607,1.968-2.509,3.21-2.09S349.282,290.183,348.751,291.756Z",
    transform: "translate(-24.062 -20.145)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7669",
    "data-name": "Path 7669",
    d: "M339.768,299.733c-2.136,3.857-6.416,5.572-9.558,3.832s-3.958-6.279-1.822-10.136,6.416-5.572,9.558-3.831,3.958,6.278,1.822,10.135",
    transform: "translate(-22.883 -20.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7670",
    "data-name": "Path 7670",
    d: "M339.768,299.733c-2.136,3.857-6.416,5.572-9.558,3.832s-3.958-6.279-1.822-10.136,6.416-5.572,9.558-3.831S341.9,295.876,339.768,299.733Z",
    transform: "translate(-22.883 -20.206)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7671",
    "data-name": "Path 7671",
    d: "M250.35,333.716a17.884,17.884,0,0,0,12.714.887",
    transform: "translate(-17.509 -23.339)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7672",
    "data-name": "Path 7672",
    d: "M236.362,349.284s1.183-5.026,8.574-8.574",
    transform: "translate(-16.53 -23.828)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7673",
    "data-name": "Path 7673",
    d: "M244.31,353.92s2.957-7.1,7.983-10.349",
    transform: "translate(-17.086 -24.028)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7674",
    "data-name": "Path 7674",
    d: "M112.207,253.272a10.184,10.184,0,0,1-3.824-8.413V216.684H35.717a12.291,12.291,0,0,1-9.5-3.952,13.3,13.3,0,0,1-3.634-9.306,14.163,14.163,0,0,1,2.422-7.9L94.614,86.141q7.775-12.111,20.78-12.111a18.661,18.661,0,0,1,12.747,4.462q5.1,4.464,5.1,13.258V198.072h18.485a8.708,8.708,0,0,1,6.884,2.741,10.11,10.11,0,0,1,0,13.131,8.7,8.7,0,0,1-6.884,2.741H133.115v28.174a10.332,10.332,0,0,1-3.7,8.413,13.007,13.007,0,0,1-8.542,3.059,13.5,13.5,0,0,1-8.669-3.059m-3.824-55.2V100.165L47.446,198.072Z",
    transform: "translate(-1.58 -5.177)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7675",
    "data-name": "Path 7675",
    d: "M224.5,253.644a50.357,50.357,0,0,1-18.421-13.769,71.225,71.225,0,0,1-11.6-20.97,121.7,121.7,0,0,1-6.31-25.369,209.673,209.673,0,0,1-1.784-28.429q0-93.954,64.123-93.955,64,0,64,93.955a216.308,216.308,0,0,1-1.721,28.3,119.213,119.213,0,0,1-6.246,25.368,71.259,71.259,0,0,1-11.6,20.972,50.987,50.987,0,0,1-18.421,13.831q-11.348,5.226-26.007,5.227T224.5,253.644m38.692-17.975a29.732,29.732,0,0,0,9.561-6.5,37.532,37.532,0,0,0,6.757-10.008,71.05,71.05,0,0,0,4.527-12.111,100.645,100.645,0,0,0,2.613-13.832q.956-7.712,1.275-14.151t.319-13.959q0-7.9-.319-14.6T286.587,136.1a107.161,107.161,0,0,0-2.678-13.832,67.291,67.291,0,0,0-4.525-11.983,37.107,37.107,0,0,0-6.757-9.817,28.85,28.85,0,0,0-9.5-6.31,34.949,34.949,0,0,0-25.243,0,28.6,28.6,0,0,0-9.433,6.246,38.006,38.006,0,0,0-6.757,9.754,61.105,61.105,0,0,0-4.527,11.983,114.23,114.23,0,0,0-2.613,13.9q-1.021,7.778-1.338,14.47t-.319,14.6q0,7.524.319,14.024t1.275,14.214a100.228,100.228,0,0,0,2.613,13.832,70.942,70.942,0,0,0,4.527,12.111,37.294,37.294,0,0,0,6.692,9.943,29.475,29.475,0,0,0,9.5,6.438,33.592,33.592,0,0,0,25.369,0",
    transform: "translate(-13.035 -4.976)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7676",
    "data-name": "Path 7676",
    d: "M435.829,253.272A10.184,10.184,0,0,1,432,244.859V216.684H359.34a12.291,12.291,0,0,1-9.5-3.952,13.294,13.294,0,0,1-3.633-9.306,14.169,14.169,0,0,1,2.421-7.9L418.237,86.141q7.773-12.111,20.78-12.111a18.665,18.665,0,0,1,12.748,4.462q5.1,4.464,5.1,13.258V198.072h18.484a8.708,8.708,0,0,1,6.884,2.741,10.11,10.11,0,0,1,0,13.131,8.7,8.7,0,0,1-6.884,2.741H456.736v28.174a10.332,10.332,0,0,1-3.7,8.413,13.006,13.006,0,0,1-8.542,3.059,13.5,13.5,0,0,1-8.669-3.059M432,198.072V100.165l-60.938,97.907Z",
    transform: "translate(-24.213 -5.177)",
    fill: "#aab2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7677",
    "data-name": "Path 7677",
    d: "M198.053,214.5s-12.418,17.444-14.193,35.185.3,29.567,5.619,34,10.644,2.661,13.6-1.479-1.774-18.627-1.774-18.627,5.026-13.9,12.714-23.653,9.166-11.235,9.166-11.235-13.305-15.08-25.132-14.193",
    transform: "translate(-12.815 -14.999)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8718",
    "data-name": "Group 8718",
    transform: "translate(170.425 199.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8717",
    "data-name": "Group 8717",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7678",
    "data-name": "Path 7678",
    d: "M198.623,214.5a95.733,95.733,0,0,0-7.237,12.574c5.935,2.394,15.15,7.254,20.992,15.87.71-1.034,1.446-2.046,2.211-3.016,7.687-9.757,9.166-11.235,9.166-11.235s-13.305-15.08-25.132-14.193",
    transform: "translate(-183.81 -214.461)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8716",
    "data-name": "Group 8716",
    transform: "translate(7.577)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8715",
    "data-name": "Group 8715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8714",
    "data-name": "Group 8714",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7679",
    "data-name": "Path 7679",
    d: "M198.623,214.5a95.733,95.733,0,0,0-7.237,12.574c5.935,2.394,15.15,7.254,20.992,15.87.71-1.034,1.446-2.046,2.211-3.016,7.687-9.757,9.166-11.235,9.166-11.235s-13.305-15.08-25.132-14.193",
    transform: "translate(-191.387 -214.461)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8720",
    "data-name": "Group 8720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8719",
    "data-name": "Group 8719",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7681",
    "data-name": "Path 7681",
    d: "M198.053,214.5s-12.418,17.444-14.193,35.185.3,29.567,5.619,34,10.644,2.661,13.6-1.479-1.774-18.627-1.774-18.627,5.026-13.9,12.714-23.653,9.166-11.235,9.166-11.235S209.88,213.612,198.053,214.5Z",
    transform: "translate(-12.815 -14.999)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7682",
    "data-name": "Path 7682",
    d: "M189.792,287.979a32.877,32.877,0,0,1-2.069-12.122",
    transform: "translate(-13.129 -19.292)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7683",
    "data-name": "Path 7683",
    d: "M198.287,289.776s-2.957-5.026-3.252-13.6",
    transform: "translate(-13.64 -19.315)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7684",
    "data-name": "Path 7684",
    d: "M202.026,247.627c0-3.118-5.938-9.2-14.2-11.834a69.477,69.477,0,0,0-2.737,8.869,35.24,35.24,0,0,1,9.249,2.965c4.435,2.366,7.688,3.548,7.688,0",
    transform: "translate(-12.945 -16.491)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7685",
    "data-name": "Path 7685",
    d: "M202.026,247.627c0-3.118-5.938-9.2-14.2-11.834a69.477,69.477,0,0,0-2.737,8.869,35.24,35.24,0,0,1,9.249,2.965C198.774,249.993,202.026,251.175,202.026,247.627Z",
    transform: "translate(-12.945 -16.491)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7686",
    "data-name": "Path 7686",
    d: "M198,215.644a99.427,99.427,0,0,0-5.246,8.978,28.7,28.7,0,0,1,7.151,2.969c9.166,5.322,10.94,5.913,7.984-1.774-1.842-4.786-6.088-8.081-9.888-10.173",
    transform: "translate(-13.48 -15.081)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7687",
    "data-name": "Path 7687",
    d: "M198,215.644a99.427,99.427,0,0,0-5.246,8.978,28.7,28.7,0,0,1,7.151,2.969c9.166,5.322,10.94,5.913,7.984-1.774C206.043,221.031,201.8,217.736,198,215.644Z",
    transform: "translate(-13.48 -15.081)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7688",
    "data-name": "Path 7688",
    d: "M301.955,205.242s14.069,16.142,17.574,33.624,2.606,29.453-2.255,34.389-10.332,3.692-13.68-.138-.061-18.711-.061-18.711-6.365-13.337-14.972-22.293-10.224-10.283-10.224-10.283,11.762-16.311,23.619-16.589",
    transform: "translate(-19.466 -14.354)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8725",
    "data-name": "Group 8725",
    transform: "translate(258.87 190.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8724",
    "data-name": "Group 8724",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7689",
    "data-name": "Path 7689",
    d: "M301.955,205.242c-11.856.277-23.619,16.589-23.619,16.589s1.616,1.326,10.224,10.283a62.887,62.887,0,0,1,4.546,5.342,50.033,50.033,0,0,1,18.609-18.175,97.3,97.3,0,0,0-9.76-14.038",
    transform: "translate(-278.336 -205.242)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8723",
    "data-name": "Group 8723",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8722",
    "data-name": "Group 8722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8721",
    "data-name": "Group 8721",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7690",
    "data-name": "Path 7690",
    d: "M301.955,205.242c-11.856.277-23.619,16.589-23.619,16.589s1.616,1.326,10.224,10.283a62.887,62.887,0,0,1,4.546,5.342,50.033,50.033,0,0,1,18.609-18.175,97.3,97.3,0,0,0-9.76-14.038",
    transform: "translate(-278.336 -205.242)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8727",
    "data-name": "Group 8727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8726",
    "data-name": "Group 8726",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7692",
    "data-name": "Path 7692",
    d: "M301.955,205.242s14.069,16.142,17.574,33.624,2.606,29.453-2.255,34.389-10.332,3.692-13.68-.138-.061-18.711-.061-18.711-6.365-13.337-14.972-22.293-10.224-10.283-10.224-10.283S290.1,205.519,301.955,205.242Z",
    transform: "translate(-19.466 -14.354)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7693",
    "data-name": "Path 7693",
    d: "M320.2,277.447a32.861,32.861,0,0,0,.871-12.268",
    transform: "translate(-22.394 -18.546)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7694",
    "data-name": "Path 7694",
    d: "M311.847,280.067s2.45-5.292,1.9-13.854",
    transform: "translate(-21.809 -18.618)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7695",
    "data-name": "Path 7695",
    d: "M302.953,238.509c-.306-3.1,5.007-9.739,12.97-13.171a69.466,69.466,0,0,1,3.595,8.558,35.251,35.251,0,0,0-8.914,3.858c-4.182,2.789-7.3,4.285-7.651.754",
    transform: "translate(-21.187 -15.759)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7696",
    "data-name": "Path 7696",
    d: "M302.953,238.509c-.306-3.1,5.007-9.739,12.97-13.171a69.466,69.466,0,0,1,3.595,8.558,35.251,35.251,0,0,0-8.914,3.858C306.422,240.544,303.3,242.039,302.953,238.509Z",
    transform: "translate(-21.187 -15.759)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7697",
    "data-name": "Path 7697",
    d: "M303.886,206.3a99.229,99.229,0,0,1,6.1,8.42,28.663,28.663,0,0,0-6.826,3.656c-8.6,6.2-10.308,6.958-8.119-.982,1.362-4.944,5.266-8.639,8.843-11.094",
    transform: "translate(-20.574 -14.428)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7698",
    "data-name": "Path 7698",
    d: "M303.886,206.3a99.229,99.229,0,0,1,6.1,8.42,28.663,28.663,0,0,0-6.826,3.656c-8.6,6.2-10.308,6.958-8.119-.982C296.406,212.453,300.309,208.757,303.886,206.3Z",
    transform: "translate(-20.574 -14.428)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7699",
    "data-name": "Path 7699",
    d: "M195.992,194.487s-3.659,12.349-2.287,17.38,7.775.458,14.179,5.947,12.339,15.361,36.58,17.19,38.888-11.244,43.919-18.563,4.573-16.008,13.264-16.466,1.373-17.38-1.372-20.125c0,0,16.923-25.155,16.923-31.559s-16.008-5.032-35.676.914c0,0-14.636-7.775-41.165-3.2s-34.3,12.349-34.3,12.349-32.932,4.116-35.219,8.233,4.574,21.5,25.156,27.9",
    transform: "translate(-11.918 -10.076)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8735",
    "data-name": "Group 8735",
    transform: "translate(158.498 134.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8734",
    "data-name": "Group 8734",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7700",
    "data-name": "Path 7700",
    d: "M301.648,201.39c8.69-.458,1.372-17.38-1.372-20.125,0,0,3.218-4.784,6.848-10.711-9.835-5.138-19.483-7.989-22.05-5.1-5.515,6.205-2.512,18.087,0,29.642s-7.536,16.579-14.569,26.627-17.082-1-17.082-1c-3.517,14.569-18.588,5.024-18.588,5.024-11.555-3.518-31.149-15.073-27.13-23.111s5.024-15.574-2.01-22.106-35.086-11.947-35.086-11.947c-1.469,4.95,5.644,21.181,25.384,27.322,0,0-3.659,12.349-2.287,17.38s7.775.458,14.179,5.946,12.338,15.362,36.58,17.191,38.888-11.245,43.919-18.563,4.574-16.008,13.265-16.466",
    transform: "translate(-170.417 -145.492)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8730",
    "data-name": "Group 8730",
    transform: "translate(0.006 18.809)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8729",
    "data-name": "Group 8729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8728",
    "data-name": "Group 8728",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7701",
    "data-name": "Path 7701",
    d: "M301.648,201.39c8.69-.458,1.372-17.38-1.372-20.125,0,0,3.218-4.784,6.848-10.711-9.835-5.138-19.483-7.989-22.05-5.1-5.515,6.205-2.512,18.087,0,29.642s-7.536,16.579-14.569,26.627-17.082-1-17.082-1c-3.517,14.569-18.588,5.024-18.588,5.024-11.555-3.518-31.149-15.073-27.13-23.111s5.024-15.574-2.01-22.106-35.086-11.947-35.086-11.947c-1.469,4.95,5.644,21.181,25.384,27.322,0,0-3.659,12.349-2.287,17.38s7.775.458,14.179,5.946,12.338,15.362,36.58,17.191,38.888-11.245,43.919-18.563,4.574-16.008,13.265-16.466",
    transform: "translate(-170.422 -164.301)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7702",
    "data-name": "Path 7702",
    d: "M270.808,206.87c.337,2.894-6.094,6.019-14.362,6.981s-15.244-.605-15.58-3.5,6.094-6.019,14.362-6.98,15.244.605,15.58,3.5",
    transform: "translate(-175.342 -148.205)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8733",
    "data-name": "Group 8733",
    transform: "translate(65.511 54.882)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8732",
    "data-name": "Group 8732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8731",
    "data-name": "Group 8731",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7703",
    "data-name": "Path 7703",
    d: "M270.808,206.87c.337,2.894-6.094,6.019-14.362,6.981s-15.244-.605-15.58-3.5,6.094-6.019,14.362-6.98,15.244.605,15.58,3.5",
    transform: "translate(-240.853 -203.087)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8737",
    "data-name": "Group 8737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8736",
    "data-name": "Group 8736",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7705",
    "data-name": "Path 7705",
    d: "M195.992,194.487s-3.659,12.349-2.287,17.38,7.775.458,14.179,5.947,12.339,15.361,36.58,17.19,38.888-11.244,43.919-18.563,4.573-16.008,13.264-16.466,1.373-17.38-1.372-20.125c0,0,16.923-25.155,16.923-31.559s-16.008-5.032-35.676.914c0,0-14.636-7.775-41.165-3.2s-34.3,12.349-34.3,12.349-32.932,4.116-35.219,8.233S175.409,188.083,195.992,194.487Z",
    transform: "translate(-11.918 -10.076)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7706",
    "data-name": "Path 7706",
    d: "M299.051,158.15c-11.827,7.983-7.688,15.966-2.365,20.4,3.25,2.708,8.475,2.328,12.057,1.622l-.006-.007s16.923-25.155,16.923-31.559c0,0-14.783,1.56-26.61,9.542",
    transform: "translate(-20.381 -10.393)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7707",
    "data-name": "Path 7707",
    d: "M299.051,158.15c-11.827,7.983-7.688,15.966-2.365,20.4,3.25,2.708,8.475,2.328,12.057,1.622l-.006-.007s16.923-25.155,16.923-31.559C325.661,148.608,310.878,150.168,299.051,158.15Z",
    transform: "translate(-20.381 -10.393)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7708",
    "data-name": "Path 7708",
    d: "M170.608,168.9c-1.469,4.95,5.645,21.181,25.384,27.322,0,0,15.061-1.468,10.034-13.59-4.689-11.31-28.415-14.126-35.419-13.732",
    transform: "translate(-11.919 -11.81)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7709",
    "data-name": "Path 7709",
    d: "M170.608,168.9c-1.469,4.95,5.645,21.181,25.384,27.322,0,0,15.061-1.468,10.034-13.59C201.337,171.32,177.611,168.5,170.608,168.9Z",
    transform: "translate(-11.919 -11.81)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7710",
    "data-name": "Path 7710",
    d: "M245.28,146.047c-1.562.27-3.055.551-4.49.84,2.365,12,6.285,31.982,9.779,31.982,3.618,0,6.163-21.9,7.306-34.182a97.791,97.791,0,0,0-12.594,1.36",
    transform: "translate(-16.84 -10.119)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7711",
    "data-name": "Path 7711",
    d: "M245.28,146.047c-1.562.27-3.055.551-4.49.84,2.365,12,6.285,31.982,9.779,31.982,3.618,0,6.163-21.9,7.306-34.182A97.791,97.791,0,0,0,245.28,146.047Z",
    transform: "translate(-16.84 -10.119)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7712",
    "data-name": "Path 7712",
    d: "M230.315,175.6c3.637-2.14,3.094-18.213,2.516-26.934a98.969,98.969,0,0,0-11.07,3.455c1.328,8.165,4.676,25.76,8.554,23.479",
    transform: "translate(-15.509 -10.397)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7713",
    "data-name": "Path 7713",
    d: "M230.315,175.6c3.637-2.14,3.094-18.213,2.516-26.934a98.969,98.969,0,0,0-11.07,3.455C223.089,160.286,226.437,177.881,230.315,175.6Z",
    transform: "translate(-15.509 -10.397)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7714",
    "data-name": "Path 7714",
    d: "M268.459,167.924c3.726,1.3,5.807-12.061,6.987-22.352a75.252,75.252,0,0,0-11.36-.962c-.114,8.455.349,21.906,4.373,23.314",
    transform: "translate(-18.468 -10.114)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7715",
    "data-name": "Path 7715",
    d: "M268.459,167.924c3.726,1.3,5.807-12.061,6.987-22.352a75.252,75.252,0,0,0-11.36-.962C263.971,153.065,264.435,166.516,268.459,167.924Z",
    transform: "translate(-18.468 -10.114)",
    fill: "none",
    stroke: "#1a2e35",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7716",
    "data-name": "Path 7716",
    d: "M262.626,219.4a14.025,14.025,0,0,0-10.307,1.263,1.03,1.03,0,0,0-.19,1.634l6.319,5.923a1.016,1.016,0,0,0,1.62-.32L263.3,220.8a1.012,1.012,0,0,0-.671-1.405",
    transform: "translate(-17.611 -15.312)",
    fill: "#e0e4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7717",
    "data-name": "Path 7717",
    d: "M262.626,219.4a14.025,14.025,0,0,0-10.307,1.263,1.03,1.03,0,0,0-.19,1.634l6.319,5.923a1.016,1.016,0,0,0,1.62-.32L263.3,220.8A1.012,1.012,0,0,0,262.626,219.4Z",
    transform: "translate(-17.611 -15.312)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7718",
    "data-name": "Path 7718",
    d: "M246.923,208.519c.872,2.289.528,4.545-.769,5.039s-3.055-.96-3.928-3.249-.528-4.545.768-5.039,3.056.96,3.929,3.249",
    transform: "translate(-16.907 -14.349)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7719",
    "data-name": "Path 7719",
    d: "M265.805,206.715c-.451,2.408.289,4.567,1.654,4.822s2.836-1.489,3.287-3.9-.289-4.566-1.654-4.821-2.836,1.488-3.287,3.9",
    transform: "translate(-18.58 -14.183)",
    fill: "#1a2e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7720",
    "data-name": "Path 7720",
    d: "M259.476,228.563s-8.433,11.457-16.12-.074",
    transform: "translate(-17.019 -15.98)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7721",
    "data-name": "Path 7721",
    d: "M258.947,228.484s5.6,5.815,11.518,2.562,2.366-8.279,2.366-8.279",
    transform: "translate(-18.11 -15.58)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7722",
    "data-name": "Path 7722",
    d: "M231.276,198.481s2.069-7.392,11.827-5.618",
    transform: "translate(-16.175 -13.469)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.34
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7723",
    "data-name": "Path 7723",
    d: "M263.066,191.51s7.392-4.435,14.193,2.661",
    transform: "translate(-18.398 -13.298)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.34
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 7.096,
    y2: 1.774,
    transform: "translate(209.484 204.822)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x1: 6.209,
    y2: 1.183,
    transform: "translate(209.483 209.257)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 4.435,
    y2: 2.365,
    transform: "translate(212.44 212.51)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y1: 1.479,
    x2: 6.209,
    transform: "translate(261.817 200.091)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 4.14,
    transform: "translate(263 204.527)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 5.618,
    y2: 1.479,
    transform: "translate(263.887 207.483)",
    fill: "none",
    stroke: "#1a2e35",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.113
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5518ccfa3b856cf41cff2a8c10fd407b.svg";
export { ForwardRef as ReactComponent };